// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1494":"415ecaf587361e76","4968":"aa3771e728aee272","5813":"252fe8404ef5c209"}[chunkId] + ".js";
};